(function initAnnouncementBarModule() {

  const MILLISECONDS_PER_SECOND = 1000;
  const SECONDS_PER_MINUTE = 60;
  const SECONDS_PER_HOUR = 3600;
  const SECONDS_PER_DAY = 86400;

  const UNIT_KEYS = ['days', 'hours', 'minutes', 'seconds'];

  function parseDeadline(deadlineText) {
    if (!deadlineText) return NaN;

    return Date.parse(deadlineText.trim().replace(' ', 'T'));
  }

  function getRemainingParts(millisecondsRemaining) {
    const totalSeconds = Math.max(0, Math.floor(millisecondsRemaining / MILLISECONDS_PER_SECOND));

    return {
      days: Math.floor(totalSeconds / SECONDS_PER_DAY),
      hours: Math.floor((totalSeconds % SECONDS_PER_DAY) / SECONDS_PER_HOUR),
      minutes: Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE),
      seconds: totalSeconds % SECONDS_PER_MINUTE,
    };
  }

  function padToTwoDigits(value) {
    return String(value).padStart(2, '0');
  }

  function handleExpiry(bar, countdown, expiredBehaviour) {
    if (expiredBehaviour === 'hide_bar') {
      bar.classList.add('is-expired');
      return;
    }

    if (expiredBehaviour === 'keep_zero') {
      countdown.removeAttribute('hidden');
      return;
    }

    countdown.setAttribute('hidden', '');
  }

  function initAnnouncementBar(bar) {
    const countdown = bar.querySelector('[data-kl-announcement-bar-countdown]');

    if (!countdown) return;

    const valueElements = {};

    UNIT_KEYS.forEach((unitKey) => {
      valueElements[unitKey] = countdown.querySelector(`[data-kl-announcement-bar-unit="${unitKey}"]`);
    });

    const hasEveryUnit = UNIT_KEYS.every((unitKey) => valueElements[unitKey]);

    if (!hasEveryUnit) {
      console.debug('Announcement bar countdown skipped: a unit is missing from the markup', {
        unitKeys: UNIT_KEYS.filter((unitKey) => !valueElements[unitKey]),
      });
      return;
    }

    const deadlineText = countdown.dataset.klAnnouncementBarDeadline;
    const deadlineTimestamp = parseDeadline(deadlineText);

    if (Number.isNaN(deadlineTimestamp)) {
      console.debug('Announcement bar countdown skipped: the deadline could not be read', {
        deadlineText,
      });
      return;
    }

    const expiredBehaviour = countdown.dataset.klAnnouncementBarExpiry;
    let intervalId = 0;

    const tick = () => {
      if (!countdown.isConnected) {
        clearInterval(intervalId);
        return;
      }

      const millisecondsRemaining = deadlineTimestamp - Date.now();
      const remainingParts = getRemainingParts(millisecondsRemaining);

      UNIT_KEYS.forEach((unitKey) => {
        valueElements[unitKey].textContent = padToTwoDigits(remainingParts[unitKey]);
      });

      if (millisecondsRemaining > 0) return;

      clearInterval(intervalId);
      handleExpiry(bar, countdown, expiredBehaviour);
    };

    const isLive = deadlineTimestamp > Date.now();

    tick();

    if (!isLive) return;

    countdown.removeAttribute('hidden');
    intervalId = setInterval(tick, MILLISECONDS_PER_SECOND);
  }

  function initAnnouncementBars(root) {
    root.querySelectorAll('[data-kl-announcement-bar]').forEach((bar) => {
      try {
        initAnnouncementBar(bar);
      } catch (error) {
        console.debug('Announcement bar countdown failed to start', { error });
      }
    });
  }

  initAnnouncementBars(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAnnouncementBars(event.target);
  });
})();
